module.exports = __webpack_public_path__ + "static/media/arrow-green.12344713.svg";